import { TemplateRef, Type } from '@angular/core';

import { CellConfig, IIdentity, Parameter } from '.';

export interface CellDisplayConfig<T extends IIdentity> {
  type: TemplateRef<any> | Type<unknown>;
  config?: CellConfig<T>;
  parameters?: Parameter;
  // this is necessary for cells that are directly displayed in edit mode : e.g. checkboxes
  allowEditing?: boolean | ((data: T) => boolean);
}
